/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnerid2Inputs */

const de__field_partnerid2 = /** @type {(inputs: _Field_Partnerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner-ID`)
};

/**

* @param {_Field_Partnerid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partnerid2 = /** @type {((inputs?: _Field_Partnerid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnerid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partnerid2(inputs)
});
export { _field_partnerid2 as "_field_partnerID" }